/**
 * RBAC feature permission names used with `isFeaturePermitted`.
 * Keep string values identical to API / features list names.
 */
export const FEATURE_PERMISSIONS = {
    // Users
    AdminPortalViewUser: "AdminPortalViewUser",
    AdminPortalCreateUser: "AdminPortalCreateUser",
    AdminPortalUpdateUser: "AdminPortalUpdateUser",
    AdminPortalSuspendUser: "AdminPortalSuspendUser",
    AdminPortalViewInvitedUser: "AdminPortalViewInvitedUser",

    // Roles
    AdminPortalViewRole: "AdminPortalViewRole",
    AdminPortalCreateRole: "AdminPortalCreateRole",
    AdminPortalUpdateRole: "AdminPortalUpdateRole",

    // Groups
    AdminPortalViewGroup: "AdminPortalViewGroup",
    AdminPortalCreateGroup: "AdminPortalCreateGroup",
    AdminPortalUpdateGroup: "AdminPortalUpdateGroup",

    // Envelopes / documents
    AdminPortalViewEnvelope: "AdminPortalViewEnvelope",
    AdminPortalViewDocument: "AdminPortalViewDocument",
    AdminPortalTransferEnvelopeOwnership: "AdminPortalTransferEnvelopeOwnership",

    // Templates
    AdminPortalViewTemplate: "AdminPortalViewTemplate",
    AdminPortalTransferTemplateOwnership: "AdminPortalTransferTemplateOwnership",

    // Forms
    AdminPortalViewForm: "AdminPortalViewForm",
    AdminPortalTransferFormOwnership: "AdminPortalTransferFormOwnership",

    // Reported users
    AdminPortalViewReportedUsers: "AdminPortalViewReportedUsers",
    AdminPortalUpdateReportedUser: "AdminPortalUpdateReportedUser",
    AdminPortalReviewReportedUserEnvelopes: "AdminPortalReviewReportedUserEnvelopes",

    // Settings / branding / integrations / AI / tags
    AdminPortalViewOrganizationSetting: "AdminPortalViewOrganizationSetting",
    AdminPortalViewBrandingSetting: "AdminPortalViewBrandingSetting",
    AdminPortalUpdateBrandingSetting: "AdminPortalUpdateBrandingSetting",
    AdminPortalViewIntegrationSetting: "AdminPortalViewIntegrationSetting",
    AdminPortalUpdateIntegrationSetting: "AdminPortalUpdateIntegrationSetting",
    AdminPortalViewLLMCredential: "AdminPortalViewLLMCredential",
    AdminPortalUpdateLLMCredential: "AdminPortalUpdateLLMCredential",
    AdminPortalViewTags: "AdminPortalViewTags",
    AdminPortalAddTags: "AdminPortalAddTags",

    // Cross-portal
    UserPortalAccess: "UserPortalAccess",
} as const;

export type FeaturePermission =
    (typeof FEATURE_PERMISSIONS)[keyof typeof FEATURE_PERMISSIONS];
